import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { DownloadLink } from './DownloadLink';
import { ScriptConfigurationForm } from './ScriptConfigurationForm';
import { TabComp } from './TabComp';
var script = [
    {
        label: 'HTML',
    },
    {
        label: 'React',
    },
    {
        label: 'Next.js',
    },
    {
        label: 'Angular',
    },
];
var fileName = 'auth.bundle.js';
var fileUrl = '/auth.bundle.js';
export default function Instructions(_a) {
    var setShowTab = _a.setShowTab;
    var _b = useState(false), showInstructions = _b[0], setShowInstructions = _b[1];
    var formattedComponentName = 'authScript'
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, function (char) { return char.toUpperCase(); });
    var instructions = [
        {
            title: "Download the scripts and move them to your project's code",
            file: {
                fileName: fileName,
                fileUrl: fileUrl,
            },
        },
        {
            script: generateEmbedScript(fileName),
            title: "Embed ".concat(formattedComponentName, " into the app."),
            description: 'Copy and paste the following code in your body tag of html code to inject the script.',
            note: 'Replace path_to_the_file with your file path.',
        },
        {
            title: "Integrate ".concat(formattedComponentName, " UI into your framework."),
            description: "Copy and Paste the following code where you want to launch the ".concat(formattedComponentName, " UI"),
            note: 'Make sure main script should available when you execute this code',
        },
    ];
    function generateEmbedScript(fileName) {
        return "<script src=\"path_to_the_file/".concat(fileName, "\" strategy=\"afterInteractive\"></script>");
    }
    return (_jsx(_Fragment, { children: showInstructions ? (_jsx(_Fragment, { children: _jsxs("div", { className: 'vas-w-full vas-flex vas-flex-col vas-rounded-lg', children: [_jsx("div", { className: 'vas-flex vas-justify-between vas-items-center vas-border-b vas-p-2 vas-text-sm', children: _jsx("p", { className: 'vas-text-primary', children: "Instructions" }) }), _jsx("div", { className: 'vas-flex vas-flex-col vas-gap-4 vas-p-2', children: instructions === null || instructions === void 0 ? void 0 : instructions.map(function (instruction, index) { return (_jsxs("div", { children: [_jsxs("span", { className: 'vas-text-lg vas-font-semibold', children: ["Step ", index + 1, ": ", instruction.title] }), instruction.description && _jsx("p", { children: instruction.description }), instruction.file && (_jsx(DownloadLink, { fileUrl: instruction.file.fileUrl, fileName: instruction.file.fileName })), instruction.note && (_jsxs("p", { children: [_jsx("strong", { children: "Note:" }), " ", instruction.note] })), (instruction === null || instruction === void 0 ? void 0 : instruction.script) && generateEmbedScript(fileName)] }, "embed-script-instruction=".concat(instruction.title))); }) }), _jsx(TabComp, { scripts: script })] }) })) : (_jsx(ScriptConfigurationForm, { onSubmitSuccess: function () {
                setShowInstructions(true);
                setShowTab(false);
            } })) }));
}
